// A Display Field's value as the text shown on an Assignments card.
//
// Tags arrive as the tag objects the Track tables render as chips
// ({ id, name, color, textColor }), so a card shows their names, comma
// separated like the server's ListItems::Tag#formatted_value. A person without
// tags gets an empty value, which the cards omit like any other blank field.
const displayFieldText = (value) => {
  if (!Array.isArray(value)) { return value; }

  return value
    .map(entry => (entry && typeof entry === 'object' ? entry.name : entry))
    .filter(Boolean)
    .join(', ');
};

export { displayFieldText };
